import { IFormField } from '../../../view-models/form.view-model';

/**
 * Gives fields a `-` placeholder so an empty value reads as "no data" rather than as blank space,
 * which is how the design draws them.
 *
 * These cards render editable inline inputs, not read-only values, so the dash belongs in the
 * placeholder — an empty input then shows `-` and replaces it as soon as the user types. Fields that
 * already declare a placeholder keep it: the design shows the Acquirer search field with its own
 * `Search…` prompt rather than a dash.
 */
export function withDashPlaceholder<T>(fields: IFormField<T>[]): IFormField<T>[] {
  return fields.map((field) => (field.placeholder ? field : { ...field, placeholder: '-' }));
}
